import Icon from '../components/Icon.vue'

Icon.register({"chevron-circle-right":{"width":512,"height":512,"paths":[{"d":"M256 8C393 8 504 119 504 256S393 504 256 504 8 393 8 256 119 8 256 8zM369.9 239L234.4 103.5C225 94.1 209.8 94.1 200.5 103.5L183.5 120.5C174.1 129.9 174.1 145.1 183.5 154.4L285.1 256 183.5 357.6C174.1 367 174.1 382.2 183.5 391.5L200.5 408.5C209.9 417.9 225.1 417.9 234.4 408.5L369.9 273C379.3 263.6 379.3 248.4 369.9 239z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-circle-right.js
// module id = wLra
// module chunks = 0